import { store } from "../redux/store"; // Import Redux store to get authentication state

export const getAuthToken = () => {
    const state = store.getState();
    const token = state.auth?.user?.tokens?.access_token;
    //const roles = state.auth.roles;
    return token ? `Bearer ${token}` : null;
  }
  